import { defineStore } from 'pinia';
import axios from "axios";

export const useCarStore = defineStore({
    id: 'car',
    state: () => ({
        cars: [],
        filteredCars: [],
        car: {},
        loading: false,
        error: null,
        context: null
    }),
    getters: {
        async getCars() {
            if (!this.cars.length) {
                await this.fetchCars();
            }
            return this.cars;
        },
    },
    actions: {
        setContext(ctx) {
            this.context = ctx
        },
        extractPrice(car) {
            let priceString = car.price_from.price;
            if (!isNaN(priceString)) {
                return parseFloat(priceString);
            }
            try {
                if (priceString.startsWith("'") && priceString.endsWith("'")) {
                    priceString = priceString.slice(1, -1);
                }
                let priceObject = JSON.parse(priceString);

                if (Array.isArray(priceObject.prijs)) {
                    return parseFloat(priceObject.prijs[0].bedrag);
                } else if (priceObject.prijs && priceObject.prijs.bedrag) {
                    return parseFloat(priceObject.prijs.bedrag);
                }
            } catch (error) {
                console.error("Error parsing price:", error);
            }
            return 0; // default price if parsing fails
        },
        sortCars(sortOrder) {
            const sortingStrategies = {
                'Price_low_high': (a, b) => this.extractPrice(a) - this.extractPrice(b),
                'Price_high_low': (a, b) => this.extractPrice(b) - this.extractPrice(a),
                'model': (a, b) => a.model.localeCompare(b.model),
                'brand': (a, b) => a.brand.localeCompare(b.brand)
            };

            if (sortingStrategies[sortOrder]) {
                this.filteredCars.sort(sortingStrategies[sortOrder]);
            }
        },
        applyFilters() {

            const el = this.context?.el

            if (!el) {
                console.error('context #crc-pls-module niet gevonden');
                return null;
            }

            const brands = el.getAttribute('data-pls-merk')?.toLowerCase().split(',').filter(Boolean) || [];
            const models = el.getAttribute('data-pls-model')?.toLowerCase().split(',').filter(Boolean) || [];
            const versions = el.getAttribute('data-pls-version')?.toLowerCase().split(',').filter(Boolean) || [];
            const transmissions = el.getAttribute('data-pls-transmission')?.toLowerCase().split(',').filter(Boolean) || [];
            const fuels = el.getAttribute('data-pls-fuel')?.toLowerCase().split(',').filter(Boolean) || []

            this.filteredCars = this.cars.filter(car => {
                const carBrand = car.brand?.toLowerCase();
                const carModel = car.model?.toLowerCase();
                const carFuel = car.fuel?.toLowerCase();
                const carTransmission = car.transmission?.toLowerCase();
                const carVersion = car.version?.toLowerCase();

                const matchesBrand = !brands.length || (carBrand && brands.map(brand => brand.toLowerCase()).some(brand => carBrand.includes(brand)));
                const matchesModel = !models.length || (carModel && models.map(model => model.toLowerCase()).some(model => carModel.includes(model)));
                const matchesVersion = !versions.length || (carVersion && versions.map(version => version.toLowerCase()).some(version => carVersion.includes(version)));
                const matchesTransmission = !transmissions.length || (carTransmission && transmissions.map(transmission => transmission.toLowerCase()).some(transmission => carTransmission.includes(transmission)));
                const matchesFuel = !fuels.length || (carFuel && fuels.map(fuel => fuel.toLowerCase()).some(fuel => carFuel.includes(fuel)));

                return matchesBrand && matchesModel && matchesVersion && matchesFuel && matchesTransmission;
            });


            const sortOrder = el.getAttribute('data-pls-sort');
            if (sortOrder) {
                this.sortCars(sortOrder);
            }

            const numCars = parseInt(el.getAttribute('data-pls-num-cars'), 10);
            this.filteredCars = isNaN(numCars) ? this.filteredCars : this.filteredCars.slice(0, numCars);
        },


        async fetchCars(forceUpdate = false) {

            if (!forceUpdate && this.cars.length > 0) {
                return this.cars;
            }

            this.loading = true;
            try {
                const apiUrl = this.context?.apiUrl
                const apiKey = this.context?.apiKey

                const response = await axios.get(apiUrl, {
                    headers: {
                        'Authorization': 'Bearer ' + apiKey,
                        'Accept': 'Application/json'
                    },
                });
                this.cars = response.data;
                this.filteredCars = [...this.cars];
                this.applyFilters();

                return this.cars;

            }
            catch (error) {
                    console.error("Error fetching cars:", error);
                    return false;
            }
            finally {
                    this.loading = false;
            }
        }
    }
});
